exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttonStyling {\r\n  background-color: #fff;\r\n  border-style: none;\r\n  padding-right: 0px;\r\n  padding-left: 0px;\r\n  margin-right: 5px\r\n}\r\n\r\n.labelForButton {\r\n  color:#fff;\r\n  background-color:#5cb85c;\r\n  border-color:#4cae4c;\r\n}\r\n\r\n.backgroundForButton {\r\n  background-color:#5cb85c;\r\n  border-color:#4cae4c;\r\n}\r\n\r\n\r\n.scrollbar {\r\n  width: 100%;\r\n  background: #fff;\r\n  overflow-x: hidden;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.file-icon {\r\n  font-size: 25px;\r\n}\r\n\r\n\r\n.upload-title{\r\n  font-weight: bold;\r\n}\r\n\r\n.panel-heading{\r\n  margin-top: 10px;\r\n  border-top: solid lightgrey;\r\n  border-top-width: 1px;\r\n}\r\n\r\n.force-overflow {\r\n  height: 175px;\r\n}\r\n\r\n.scrollbar-primary::-webkit-scrollbar {\r\n  width: 12px;\r\n  background-color: #F5F5F5;\r\n}\r\n\r\n.scrollbar-primary::-webkit-scrollbar-thumb {\r\n  border-radius: 10px;\r\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0.1, 0.1);\r\n  background-color: #bbbbbb;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/ePlanner Maintenance/src/app/controllers/file-handler/file-handler-view.component.css
// module id = ../../../../../src/app/controllers/file-handler/file-handler-view.component.css
// module chunks = main